module.exports = __webpack_public_path__ + "img/cynergy-logo-no-text-white.85d7a170.png";